import styles from './PixelTemplate.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const PixelTemplate = () => {
  return /*#__PURE__*/_jsx("div", {
    className: styles['container']
  });
};